import { Box, Text } from '@factorialco/deprecated-design-system'
import { OneModal } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface PrivacyModalProps {
  onOpen: boolean
  onClose: () => void
}

export const PrivacyModal = ({ onOpen, onClose }: PrivacyModalProps) => {
  return (
    <OneModal isOpen={onOpen} onClose={onClose}>
      <OneModal.Header title={i18n.t('meetings.prejoin.privacy.title')} />
      <OneModal.Content withPadding>
        <Box gap="s12">
          <Text.Normal size="200">{i18n.t('meetings.prejoin.privacy.content_1')}</Text.Normal>
          <Text.Normal size="200">{i18n.t('meetings.prejoin.privacy.content_2')}</Text.Normal>
        </Box>
      </OneModal.Content>
    </OneModal>
  )
}
